import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 bg-[#FAFAFA] border-y border-gray-200" data-id="element-163">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          <ShieldCheck className="w-16 h-16 text-bordeaux mx-auto mb-6" data-id="element-166" />
          <h2 className="text-3xl font-playfair text-deep-black mb-6" data-id="element-167">
            Pruébalo sin riesgos durante{' '}
            <span className="italic text-bordeaux" data-id="element-168">30 días</span>
          </h2>

          <div className="font-inter text-gray-700 text-lg leading-relaxed space-y-4" data-id="element-169">
            <p data-id="element-170">
              Si después de leer la guía y hacer los ejercicios{' '}
              <strong className="font-bold text-deep-black" data-id="element-171">
                no sentís el cambio
              </strong>{' '}
              en tu energía…
            </p>
            <p data-id="element-172">Si los hombres no empiezan a reaccionar diferente…</p>
            <p className="font-bold text-deep-black text-xl pt-4" data-id="element-173">
              Te devolvemos el{' '}
              <span className="bg-gold/30 px-1.5 rounded-sm" data-id="element-174">
                100% de tu plata
              </span>
              .
            </p>
            
          </div>
        </motion.div>
      </div>
    </section>;
}